import { render } from "./index.vue?vue&type=template&id=eb3894be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=eb3894be&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-eb3894be"

export default script